import { useEffect, useMemo, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import api from "@/lib/api";
import { SectionHead } from "@/components/landing/HeroSections";
import { MapPin } from "lucide-react";

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 10);
    else if (points.length > 1) map.fitBounds(points, { padding: [40, 40], maxZoom: 10 });
  }, [points, map]);
  return null;
}

export default function DriverAreaMap({ d }) {
  const m = d.map || {};
  const [towns, setTowns] = useState(null);
  useEffect(() => { api.get("/public/driver-areas").then((r) => setTowns(r.data)).catch(() => setTowns([])); }, []);
  const points = useMemo(() => (towns || []).map((t) => [t.lat, t.lng]), [towns]);
  if (towns && towns.length === 0) return null;

  return (
    <section id="areas" className="scroll-mt-24 bg-slate-50" data-testid="drivers-map">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-20 lg:grid-cols-12 lg:px-8 lg:py-24">
        <div className="lg:col-span-4">
          <SectionHead overline={m.overline} heading={m.heading} sub={m.subheading} />
          <div className="mt-8 flex flex-wrap gap-2">
            {(towns || []).map((t, i) => (
              <span key={t.town} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700" data-testid={`drivers-town-${i}`}>
                <MapPin className="h-4 w-4 text-brand-orange" /> {t.town}
              </span>
            ))}
          </div>
        </div>
        <div className="relative z-0 h-[380px] overflow-hidden rounded-3xl border border-slate-200 lg:col-span-8 lg:h-[460px]" data-testid="drivers-map-canvas">
          <MapContainer center={[54.0, -2.5]} zoom={6} scrollWheelZoom={false} className="h-full w-full">
            <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {(towns || []).map((t) => (
              <CircleMarker key={t.town} center={[t.lat, t.lng]} radius={14} pathOptions={{ color: "#F97316", fillColor: "#F97316", fillOpacity: 0.35, weight: 2 }}>
                <Tooltip direction="top" offset={[0, -10]}>{t.town}</Tooltip>
              </CircleMarker>
            ))}
            <Fit points={points} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
}
